const numeral = require('numeral');

export const minValue = {
    validate: (value, params) => {
        const numVal = numeral(value).value();
        const minVal = numeral(params['minValue']).value();
        return numVal >= minVal;
    },
    params: ['minValue'],
    message: `Giá trị nhỏ nhất của '{_field_}' phải là {minValue}.`,
}